<template>
  <div class="p-4 text-center rounded border border-black-light-2 mt-8">
    <div v-if="unavailability" class="flex flex-col items-center">
      <h4 class="lg:hidden my-4">
        Unfortunately, there is no availability at
        {{ supplierInfo.supplier.name }} for your dates
      </h4>
      <img
        :style="{ width: '300px' }"
        class="w-full"
        src="/img/illustrations_speech.png"
        alt="zublu_illustrations_speech"
      />
      <h4 class="mdsm:hidden">
        Unfortunately, there is no availability at
        {{ supplierInfo.supplier.name }} for your dates
      </h4>
      <p class="mt-4">
        Get in touch with our expert travel team to explore different dates or
        resorts
      </p>
      <trengo-link>
        <template v-slot="{ openChat }">
          <button
            type="button"
            class="btn btn-primary btn-outlined flex items-center sm:justify-center mt-4 mb-8"
            @click="openChat()"
          >
            <svg width="24" height="24" class="fill-current mr-2">
              <use xlink:href="/img/sprite.svg#ic_chat"></use>
            </svg>
            Chat with us
          </button>
        </template>
      </trengo-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TrengoLink from "../../core/TrengoLink";

export default {
  components: {
    TrengoLink,
  },
  computed: {
    ...mapState(["supplierInfo", "unavailability", "roomsFilter", "dates"]),
  },
};
</script>
